module.exports = __webpack_public_path__ + "static/media/dead_battery.0f197f55.svg";